import { User } from '/@src/models/user'
import {
  Article,
  Faq,
  FaqItem,
  Group,
  Tag,
  TagRelation,
} from '/@src/models/graphApi'
import { ArticleType, ContentKind, ContentStatus } from '/@src/models/api'
import { VipLevel } from '/@src/composable/user/useVip'
import { MediaCategory } from '/@src/composable/media/useMediaCategory'
import { RelationKind } from '../__generated__/generated-gql-types'
export type TabStatus = 'all' | 'published' | 'draft' | 'deleted'
export type WordsFilter = '2k' | '2k-3k' | '3k-5k' | '5k'
export enum Platform {
  Android = 'android',
  iOS = 'ios',
  Web = 'web',
  Lite = 'lite',
  Wap = 'wap',
}
export enum ContentLevel {
  INSTITUTION = 110,
  NORMAL = 1,
  BLACK_GOLD,
  META,
}
export enum ScopeType {
  ALL = 0,
  ASSIGN = 1,
  BLACK_GOLD = 2,
  META = 3,
}
export enum Gender {
  Male = 1,
  Female,
}
export enum ContentStatusValue {
  ALL,
  DRAFT = 1,
  PUBLISHED = 2,
  DELETED = 3,
}
export interface Content {
  datetime?: string
  id?: number
  raw_id?: number
  title?: string
  display_time?: string
  is_home?: boolean
  vip_visibility?: ContentLevel
  comment_count?: number
  tags?: Tag[]
  tag_relations?: TagRelation[]
  // 是否选择
  select?: boolean
  // 类型
  kind?: ContentKind
}

export interface ProductContent {
  cover_uri?: string
  commodity_id?: number
  id?: number
  name?: string
  platforms?: string[]
  price?: number
  select?: boolean
  spec_attrs?: Spec_attrs[]
}

export interface CouponContent {
  id?: number
  name?: string
  rule: object
  scope_text?: string
  select?: boolean
  status?: string
  user_scopes?: string[]
}

export interface TagRelations {
  k?: ContentKind
  id: number
  group: number
}

export interface LocalArticle {
  title?: string
  body?: string
  timestamp?: number
}

export enum EditorEvent {
  AUTO_SAVED_LOCAL = 'auto-save-draft',
  AUTO_SAVED_REMOTE = 'auto-save-remote',
  LOADING_TEMPLATE = 'loading-template',
  LOADING = 'loading',
  SAVE_COMPLETE = 'save-complete',
  AUTO_LOAD_TEMPLATE = 'auto-load-template',
}

export interface EditorMenu {
  name: string
  key: string
  iconClass: string
}
export interface RichTextItem {
  id: number
  title: string
  content: string
  timestamp?: number
}
export interface ArticleTemplate {
  title: string
  template: string
}
export interface Spec_attrs {
  key?: string
  value?: string
}
export interface RawArticle extends Content {
  author?: User
  author_id: number
  body_summary?: string
  cover_uri?: string | null | undefined
  source_uri?: string
  page_views?: number
  words_count?: number
  planned_publish_at?: string
  free_expired_at?: string
  free_at?: string
  is_cooperation: boolean
  is_front?: boolean
  is_featured?: boolean
  body: string
  body_preview?: string | null
  cover_slide_uris?: string[] | null
  attachments?: MediaFile[]
  article_type?: ArticleType
  status: ContentStatus
}

export interface ArticleModel extends Article {
  displayTime?: Date
  scheduleTime?: Date
  isHome: boolean
}

export interface RawVideo extends Content {
  cover_url: string | null | undefined
  author?: User
  title: string
  description?: string | null
  cover?: string | null
  planned_publish_at?: string | null
  duration: number
  comment_count: number
  page_views: number
  created_at: string
  related_article_ids: number[]
  related_research_ids: number[]
  free_expired_at?: string
  schedule?: ScheduleOption
  sets: VideoEpisode[]
  status: ContentStatusValue
}

export interface RawRoadshow extends Content {
  summary?: string
  status: ContentStatusValue
  live_status: LiveStatus
  poster?: string | null
  people?: string | null
  video_id?: number
  start_time?: string
  end_time?: string
  updated_at?: string
  live_method: LiveStatus
  created_at?: string
}

export interface ScheduleOption {
  open: boolean
  t?: string
}

export interface VideoEpisode {
  url?: string | undefined
  id?: number | null
  key?: string | null
  qiniu_url?: string
  preview_qiniu_url?: string | null
  duration?: number | null
  size?: number
  name: string
  thumbnails?: Thumbnail[]
  preview_url?: string
  type: string
  /**
   * 后台会判断是否需要生成预览视频
   */
  preview_ok?: boolean | null
  /**
   * 后台会判断是否需要生成视频截图
   */
  thumbnail_ok?: boolean | null
}
export interface Thumbnail {
  qiniu_url: string
}

/**
 * 媒体库文件
 */
export interface MediaFile {
  id?: number
  file_uri: string
  file_name?: string
  file_meta?: MediaMeta
  duration?: number
  file_extension?: string
  created_at?: string
  logo?: string
  is_research?: boolean
  only_institutional?: boolean
  institutional_categories?: MediaCategory[]
  vip_visibility?: VipLevel
  ai_summary?: AiSummary
  ai_info?: AiSummary
  aiDerivatives?: AiDerivatives
  ai_derivatives?: AiDerivatives[]
  tags?: Tag[]
  tag_relations?: TagRelations[]
  // 摘要，可能是ai生成的摘要
  summary?: string
  body_audio_request?: {
    body_text: string
    enable: boolean
  }
  parse_request?: {
    embedding_enable: boolean
  }
}

export interface AiSummary {
  enable: boolean
  prompt?: string
  model?: string
}

export interface AiDerivatives {
  prompt?: string
  content_kind?: ContentKind
  model?: string
  enable?: boolean
}

export interface MediaMeta {
  fsize: number
  mime?: string
  mimeType?: string
  hash?: string
}

export interface TagData extends Tag {
  select?: boolean
  // 标记是否需要被删除
  delete?: boolean
  //是否关联为典藏库
  treasury?: boolean
}

export interface GroupData extends Group {
  select?: boolean
  delete?: boolean
}

export interface FaqContent extends Faq {}

export interface RoadmapItem {
  id?: number
  title?: string
  kind?: ContentKind
  datetime?: string
  url?: string
  isHeadNode?: boolean
  children?: RoadmapItem[]
}
export interface RoadmapData extends RoadmapItem {
  isOpen: boolean
}
export interface RoadmapContent extends Content {
  content?: string
}
export enum LiveStatus {
  NOT_START = 1,
  IN_PROGRESS = 2,
  FINISHED = 3,
}
export interface LinkContent extends Content {
  to: string
  description?: string
  cover?: string
  showInHomeBanner?: boolean
}

export interface CalendarContent extends Article {
  description?: string
  pictures?: MediaFile[]
  reports?: MediaFile[]
  source_uri?: string
}
export enum JsonEditorType {
  OBJECT = 'object',
  ARRAY = 'array',
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  ENUM = 'enum',
}
export interface JsonSchemaEditorItem {
  title?: string
  type: JsonEditorType
  fieldName?: string
  properties?: JsonSchemaEditorItem[]
  isOpen: boolean
  isDisplayTime: boolean
  isRoot: boolean
  enum?: JsonEditorEnum[]
}

export interface JsonEditorEnum {
  title?: string
  value: number | number
}

export enum JsonSchemaFormat {
  DATETIME = 'datetime-local',
}

export interface JsonSchema {
  title?: string
  format?: string
  type?: JsonEditorType
  properties?: object
  items?: JsonSchema
  enum?: any[]
  options?: JsonSchemaOption
}

export interface JsonSchemaOption {
  enum_titles: any[]
}

export type JsonValue = string | number | boolean | [] | object

export interface JsonEditorData {
  title?: string
  type: JsonEditorType
  fieldName?: string
  value?: JsonValue
  enum?: JsonEditorEnum[]
  children?: JsonEditorData[]
  isOpen: boolean
  isDisplayTime: boolean
  // 是否是array中的item项
  isArrayItem: boolean
  // 是否多行文字，使用textarea显示
  isMultiText: boolean
  isRoot: boolean
}

export interface SelectionModel<T> {
  data: T
  selected: boolean
}

export enum ToolbarButtonType {
  TAG = 'tag',
  LINK = 'link',
  IMAGE = 'image',
  REPORT = 'report',
}

export enum MediaFileAction {
  DOWNLOAD = 'download',
  COPY_LINK = 'copy_link',
  EDIT = 'edit',
  DELETE = 'delete',
}
